module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8rAyv"))).then(() => parcelRequire('d0iPb'));